var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPizzaCircleHalf2X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.5,
    x2: 0.497,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fae7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_176",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cecece"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_88",
    x: 16,
    y: 4,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cecece"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2380",
    "data-name": "Grupo 2380",
    transform: "translate(-4227 -1368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4227, 1368)",
    filter: "url(#Elipse_176)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_176-2",
    "data-name": "Elipse 176",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(9 6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Componente_Circulo",
    "data-name": "Componente Circulo",
    transform: "translate(4252 1378)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25, -10)",
    filter: "url(#Elipse_88)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_88-2",
    "data-name": "Elipse 88",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(25 10)",
    fill: "#3fae7f",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2012",
    "data-name": "Grupo 2012"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_84",
    "data-name": "Elipse 84",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#418c6c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "x2",
    transform: "translate(9 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "x2")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPizzaCircleHalf2X2);
export default __webpack_public_path__ + "static/media/ic_pizza_circle_half2_x2.377682f04d711306cabfcfafc391fa90.svg";
export { ForwardRef as ReactComponent };